import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import * as React from 'react'
import {connect} from 'react-redux'
import {Button, Col, FormGroup, Input, Label,
        Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app'
import { FlashMessage } from '../../components/flash-message'
import * as Link from '../../components/link'
import {Loading} from '../../components/loading'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as CommunityConfig from '../community-config'
import * as GridCell from '../grid-cell'
import * as ScheduleTypes from '../schedules/types'
import * as ScheduleUtils from '../schedules/utils'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

type AppProps = App.WrappedState

interface SubmitAddEventProps {
  communities?: CommunityConfig.Communities,
  events: Types.State,
  submitModal: RasaModal.Submit<Types.ModalData>,
}

type AddEventModalProps =
  RasaModal.ComponentState<Types.ModalData> &
  RasaModal.DispatchState &
  SubmitAddEventProps &
  Types.State &
  AppProps

export const AddEventModal =
  ({app, events, modal, showModal, submitModal, updateModal}: AddEventModalProps) =>
  <Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
    <form className="k-form"
          onSubmit={Link.preventDefaultThen(() => submitModal(app.selectedCommunity, modal.data))}>
      <FlashMessage />
      <ModalHeader toggle={showModal}>{modal.modalTitle}</ModalHeader>
      <ModalBody>
        <div className="field">
          <RasaInput.RasaInput
            label=""
            placeholder="Report Name"
            value={modal.data.name}
            validation={RasaInput.validatePresent(modal.data.name)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateModal({name: 'name', value: e.target.value})} />
        </div>
        <div className="field">
        <RasaInput.RasaSelectInput
          label=""
          value={modal.data.schedule_type}
          required={true}
          disabled = {modal.modalTitle === 'Edit Report'}
          options={Utils.getScheduleTypes(events.scheduleTypes)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateModal({name: 'schedule_type', value: e.target.value})}/>
        </div>
        {modal.data.schedule_type !== 'data' &&
        <div className="field">
          <RasaInput.RasaInput
            label=""
            placeholder="Time"
            value={modal.data.time}
            validation={RasaInput.validateTime(modal.data.time)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateModal({name: 'time', value: e.target.value})} />
          <RasaInput.RasaInput
            label=""
            placeholder="Frequency"
            value={modal.data.frequency}
            disabled={true}
            validation={RasaInput.validatePresent(modal.data.frequency)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateModal({name: 'frequency', value: e.target.value})} />
          {ScheduleUtils.needsDays(modal.data.frequency) &&
          <div className="field form-inline">
          {ScheduleUtils.toSelectedDays(modal.data.days).map((d: ScheduleTypes.SelectedFrequencyUnit, idx: number) =>
          <FormGroup check className="mb-2 mr-sm-2 mb-sm-0" key={`day-checkbox-${idx}`}>
            <Label check>
              <Input type="checkbox"
                    checked={d.isActive}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      updateModal({
                        name: 'days',
                        value: ScheduleUtils.toDaysString(modal.data.days, d),
                      })} />
              <span className="field-label">{d.unit.name}</span>
            </Label>
          </FormGroup>)}
        </div>}
        </div>}
        <div className="field">
          <RasaInput.RasaInput
            label="Add Comma Separated emails"
            placeholder="To Email - Comma Separated"
            value={modal.data.to_email}
            validation={RasaInput.validateEmailList(RasaInput.trimList(RasaInput.splitString(modal.data.to_email)))}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateModal({name: 'to_email', value: e.target.value})} />
        </div>
        <PreferenceGridCopmonent {...modal.data} />
      </ModalBody>
      <ModalFooter>
        {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
        <Button color="primary"
          disabled={modal.isSubmitting || !Utils.addEventModalStateValid({
            ...modal.data,
            community_identifier: app.selectedCommunity,
          })}
        >
          Save
        </Button>
        <Button onClick={showModal}>Cancel</Button>
      </ModalFooter>
    </form>
  </Modal>

export const AddEventModalConnect = connect(
  ({app, events}: AppProps & EventsProps) => ({app, scheduleTypes: events.scheduleTypes}),
  {
    showModal: Actions.showAddEventModal,
    submitModal: Actions.createOrUpdate,
    updateModal: Actions.updateAddEventModalField,
  },
)(AddEventModal)

interface HeaderProps {
  events: Types.State,
  showAddEventModal: RasaModal.Toggle,
}

const Header = ({events, showAddEventModal}: HeaderProps ) => {
  return <div>
    <FlashMessage />
    <Row className="margin-auto">
      <Col sm="12" className="text-left page-header--padding">
        <div className="page-header">
          <Row>
            <Col sm="12" md="4">
              <span className="title">Admin Reports</span>
            </Col>
            {Utils.shouldShowAddReport(events) ?
            <Col sm="12" md="4">
              <Button
                className="secondary-button"
                onClick={showAddEventModal}
                title="Add Report"
                disabled={!Utils.shouldShowAddReport(events)}
              >
                Add
              </Button>
            </Col>
            : null }
          </Row>
        </div>
      </Col>
    </Row>
  </div>
}

const HeaderConnect = connect(
  ({events}: Types.WrappedState) => ({events}),
  ({
    showAddEventModal: Actions.showAddEventModal,
  }),
)(Header)

interface DispatchProps {
  communities?: CommunityConfig.Communities,
  dispatch: Redux.Dispatch<Redux.Action>,
}
type EventsProps = Types.WrappedState & DispatchProps

export const Events = (props: EventsProps) => {
  return props.events.view.isLoading ?
      <Loading center size={Loading.Sizes.LARGE} />
    :
      <div>
        <Row>
          <Col>
            <HeaderConnect />
          </Col>
        </Row>
        <AddEventModalConnect modal={props.events.modal}
                              communities={props.communities}
                              data={props.events.data}
                              page={props.events.page}
                              search={props.events.search}
                              events={props.events}
                              view={props.events.view}
                             />
        <div>
          <Row>
            <Col>
              <EventGridCopmonent {...props} />
            </Col>
          </Row>
        </div>
      </div>
}

class EventGridCopmonent extends React.PureComponent<EventsProps> {
  constructor(props: EventsProps) {
    super(props)
  }
  public render() {
    const {events} = this.props
    return <div>
      <Grid data={Request.withDispatch(events.data, this.props.dispatch)}
            pageable={false}
            sortable={{ allowUnsort: true }}
            sort={events.view.sort}
            onSortChange={(e: GridSortChangeEvent) => this.props.dispatch({
                                options: { value: e.sort },
                                type: Sortable.sortTableConstant(Constants.FETCH_EVENTS),
            })}>
        <GridColumn field="name" title="Name" />
        <GridColumn field="time" title="Time" sortable={false} />
        <GridColumn field="email_list" sortable={false} title="To Email" />
        <GridColumn cell={GridCell.DateTimeCell} field="last_run_datetime" title="Last Run" />
        <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" />
        <GridColumn cell={Render.EditCell}  sortable={false} />
      </Grid>
    </div>
  }
}

// tslint:disable-next-line
class PreferenceGridCopmonent extends React.PureComponent<any> {
  constructor(props: any) {
    super(props)
  }
  public render() {
    const {preferences} = this.props
    return <div>
      <div className="user-preference-title">User Preferences</div>
      <Grid data={Request.withDispatch(preferences, this.props.dispatch)}>
        <GridColumn field="email_address" sortable={false} title="Email" />
        <GridColumn cell={Render.PreferenceActiveCell} field="is_active" title="Active" />
      </Grid>
    </div>
  }
}

type AdminEventState = Types.WrappedState & CommunityConfig.CommunitiesWrappedState
export const AdminEventsConnected = connect(
  ({communities, events}: AdminEventState) =>
    ({
      communities,
      events,
    }),
  (dispatch: any) => ({
    dispatch,
  }),
)(Events)



// WEBPACK FOOTER //
// ./src/pages/admin-reports/component.tsx